import React from 'react'
import classnames from 'classnames/bind'
// @ts-ignore no types
import { PageLayout } from '@adc/ui-adc'
// @ts-ignore no types
import cls from './styles.scss'

const cx = classnames.bind(cls)

const MainSectionPanel = ({ children }: { children: JSX.Element[] }) => {
  return (
    <div className={cx('background')}>
      <PageLayout width='large' horizontalPadding>
        {children}
      </PageLayout>
    </div>
  )
}

export default MainSectionPanel
